import React, { Component } from 'react';
import fileImg from 'Images/new_csv_icon.svg';
import PropTypes from 'prop-types';
import LoadingGif from 'Images/faraday_loadingbar.gif';
import {
  FileUploaderContainer,
  FileName,
  LongTimeMessage,
  CustomProgressBar,
  File, LoadingIcon
} from './styled';

class FileUploader extends Component {
  componentDidMount () {
    const { uploadFile } = this.props;
    uploadFile();
  }

  render () {
    const {
      currentUploadState,
      currentUploadError,
      filenames,
      height
    } = this.props;

    return (
      <FileUploaderContainer height={ height }>
        <>
          <File src={ fileImg } alt="File" />
          <FileName currentUploadState={ currentUploadState }>{filenames}</FileName>
          { currentUploadState !== 'Error' &&
            (
              <CustomProgressBar currentUploadState={ currentUploadState }>
                <LoadingIcon src={ LoadingGif } />
              </CustomProgressBar>
            )
          }
          <LongTimeMessage>{ currentUploadState === 'Error' ? currentUploadError : 'This may take a while' }</LongTimeMessage>
        </>
      </FileUploaderContainer>
    );
  }
}

FileUploader.propTypes = {
  uploadFile: PropTypes.func.isRequired,
  height: PropTypes.string
};

FileUploader.defaultProps = {
  height: null
};

export default FileUploader;
